module.exports = __webpack_public_path__ + "img/wealth_of_knowledge.d4cc70c0.svg";